import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Separator } from '../../../../common/separator'
import { HighlightItem } from './HighLightItem'
import './i18n'
import classes from './index.module.scss'

export const HighlightInformation = ({
  highlights,
  isLoading,
  isWarningWhenNotHasPanel,
  goToSettingPanel,
}) => {
  const [isShowPopupWarning, setIsShowPopupWarning] = useState(false)

  const closePopup = () => {
    setIsShowPopupWarning(false)
  }

  const goToSetting = () => {
    setIsShowPopupWarning(false)
    goToSettingPanel()
  }

  return (
    highlights.length > 0 && (
      <Element
        className={classes.container}
        style={{ borderBottomColor: '#e5e5e8' }}
      >
        {isLoading && <Loading />}
        <Element
          className={classes.highlightList}
          style={{ opacity: isLoading ? 0 : 1 }}
        >
          {highlights.map((item, index) => (
            <React.Fragment key={index}>
              <HighlightItem
                item={item}
                isWarningWhenNotHasPanel={isWarningWhenNotHasPanel}
                setIsShowPopupWarning={setIsShowPopupWarning}
              />
              {item.isShowSeparator && (
                <Separator width={1} backgroundColor="#9C9C9C" />
              )}
            </React.Fragment>
          ))}
        </Element>
        {isWarningWhenNotHasPanel && (
          <PopupAction
            isShow={isShowPopupWarning}
            title="highlightInformationCompanyAnalysis.WARNING"
            handleClose={closePopup}
            btnCancel={{
              label: 'highlightInformationCompanyAnalysis.CLOSE',
              event: closePopup,
              isI18n: true,
            }}
          >
            <Translate value="highlightInformationCompanyAnalysis.NOTE_1" />
            <Element
              onClick={goToSetting}
              elementName="span"
              style={{ color: '#2C73E8' }}
              className="cursorPointer"
            >
              <Translate value="highlightInformationCompanyAnalysis.HYPER_LINK" />
            </Element>
            <Translate value="highlightInformationCompanyAnalysis.NOTE_2" />
          </PopupAction>
        )}
      </Element>
    )
  )
}

HighlightInformation.propTypes = {
  isLoading: PropTypes.bool,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      detail: PropTypes.node,
      scrollElementId: PropTypes.string,
      scrollElementClass: PropTypes.string,
      isShowSeparator: PropTypes.bool,
      isI18n: PropTypes.bool,
      formatVal: PropTypes.func,
    }),
  ),
  isWarningWhenNotHasPanel: PropTypes.bool,
  goToSettingPanel: PropTypes.func,
}

HighlightInformation.defaultProps = {
  isLoading: false,
  isWarningWhenNotHasPanel: false,
  highlights: [],
}
